import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getCurrency } from 'utils/currencyUtil';
import { useCreateWallet } from 'services/reactQueryHooks/wallet';
import useAmplitude from 'utils/hooks/useAmplitude';
import { AMPLITUDE_EVENT_TYPES, AMPLITUDE_WALLET_PROPERTY_VALUES } from 'constants/amplitude';
import { ROUTES } from 'constants.js';
import { getWalletTermsUrl, buildCreateWalletPayload, getLowBalanceInputMethod } from './helper';

const { surface: SURFACES } = AMPLITUDE_WALLET_PROPERTY_VALUES;

const useCreateWalletPage = () => {
  const history = useHistory();
  const { sendAmplitudeEvent } = useAmplitude();
  const currentCorporation = useSelector(state => state.user.currentCorporation);
  const { mutate: createWallet, isLoading: isCreateWalletLoading } = useCreateWallet();

  const country = currentCorporation?.country;
  const currency = getCurrency(country);
  const termsUrl = getWalletTermsUrl(country);
  const companyName = currentCorporation?.corporateClientName;

  const handleLowBalanceAlertAmountSelected = ({ amount, inputMethod }) => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletLowBalanceAlertAmountSelected, {
      currency: currency.code,
      surface: SURFACES.walletCreate,
      amount,
      inputMethod,
    });
  };

  const handleBack = () => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletCreateBackButtonClicked);
    history.push(ROUTES.WALLET);
  };

  const handleCreateWallet = formValues => {
    sendAmplitudeEvent(AMPLITUDE_EVENT_TYPES.walletCreateSubmitButtonClicked, {
      currency: currency.code,
      surface: SURFACES.walletCreate,
      amount: Number(formValues.lowBalanceAlertAmount),
      inputMethod: getLowBalanceInputMethod(formValues.lowBalanceOtherAmount),
    });
    createWallet(buildCreateWalletPayload(formValues), {
      onSuccess: () => history.push(ROUTES.WALLET),
    });
  };

  return {
    currency,
    termsUrl,
    companyName,
    isCreateWalletLoading,
    onCreateWallet: handleCreateWallet,
    onBack: handleBack,
    onLowBalanceAlertAmountSelected: handleLowBalanceAlertAmountSelected,
  };
};

export default useCreateWalletPage;
